export const categories = [
  {
    id: "changpian",
    name: "长篇连载",
    en: "SERIAL",
    desc: "持续更新的长篇同人，剧情展开完整，适合沉浸式追更。",
    icon: "ri-stack-line",
  },
  {
    id: "rexue",
    name: "热血战斗",
    en: "ACTION",
    desc: "以忍术对决、任务与战斗为核心的高燃同人作品。",
    icon: "ri-flashlight-line",
  },
  {
    id: "qingshui",
    name: "清水治愈",
    en: "WHOLESOME",
    desc: "温柔治愈向同人，描写日常羁绊与平静温暖的小故事。",
    icon: "ri-heart-line",
  },
  {
    id: "chuanyue",
    name: "穿越重生",
    en: "ISEKAI",
    desc: "主角穿越或重生进火影世界，改写命运走向的设定向同人。",
    icon: "ri-shuffle-line",
  },
  {
    id: "yuanzhu",
    name: "原著向",
    en: "CANON",
    desc: "严格贴合原著剧情与人物设定的正剧向同人。",
    icon: "ri-book-2-line",
  },
  {
    id: "ganqing",
    name: "感情线",
    en: "ROMANCE",
    desc: "聚焦角色情感羁绊与人物关系的细腻向同人。",
    icon: "ri-heart-add-line",
  },
  {
    id: "duanpian",
    name: "短篇集锦",
    en: "SHORT",
    desc: "篇幅精悍的短篇同人，快速阅读，回味悠长。",
    icon: "ri-quill-pen-line",
  },
  {
    id: "wanjie",
    name: "完结佳作",
    en: "COMPLETE",
    desc: "已完结的高分同人作品，一次性读完的畅快体验。",
    icon: "ri-check-double-line",
  },
];

export const categoryOptions = categories;